import React from 'react';
import './PC.css';
import Adobe from '../../img/speakers/Adobe.png'
import Gosebrink from '../../img/speakers/Gosebrink.png'
import JobCloud from '../../img/speakers/JobCloud.png'
import Lowgular from '../../img/speakers/Lowgular.png'
import OfferingSolutionsSoftware from '../../img/speakers/OfferingSolutionsSoftware.png'
import Radzio from '../../img/speakers/Radzio.png'
import Stanimirović from '../../img/speakers/Stanimirović.png'
import Steyer from '../../img/speakers/Steyer.png'
import Subramanian from '../../img/speakers/Subramanian.png'
import Michalski from '../../img/speakers/Michalski.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Subramanian,
          name: 'Deepa Subramanian',
          position: 'Developer ',
          ln: 'https://www.linkedin.com/in/sdkdeepa/',
          tw: 'https://twitter.com/sdk_deepa',
          logo: Adobe,
        },
        {
          photo: Stanimirović,
          name: 'Marko Stanimirović',
          position: 'Senior Frontend Engineer',
          ln: 'https://www.linkedin.com/in/markostanimirovic/',
          tw: 'https://twitter.com/MarkoStDev',
          github: 'https://github.com/markostanimirovic',
          logo: JobCloud,
        },
        {
          photo: Gosebrink,
          name: 'Fabian Gosebrink',
          position: 'Founder',
          tw: 'https://twitter.com/FabianGosebrink',
          logo: OfferingSolutionsSoftware,
        },
        {
          photo: Michalski,
          name: 'Kamil Michalski',
          position: 'Frontend Engineer',
          ln: 'https://www.linkedin.com/in/kamil-michalski-12915210b/',
          logo: Lowgular,
        },
        {
          photo: Radzio,
          name: 'Greg Radzio',
          position: 'Principal Angular Developer',
          ln: 'https://www.linkedin.com/in/greg-radzio',
          tw: 'https://twitter.com/greg_radzio',
          github: 'https://github.com/gradzio',
          logo: Lowgular,
        },
        {
          photo: Steyer,
          name: 'Manfred Steyer',
          position: 'Trainer, Consultant, Architect @Angular Architects',
          tw: 'https://twitter.com/ManfredSteyer',
        },
      ],
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='pcc'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous event</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}